function sleep(ms: number = 500) {
	return new Promise(resolve => setTimeout(resolve, ms))
}

declare global {
	interface Window {
		fbq: (...args: any[]) => void
		_fbq: any
	}
}

// Types for Facebook Pixel events
interface PixelEvent {
	value?: number
	currency?: string
	content_name?: string
	content_type?: string
	content_ids?: string[]
	content_category?: string
	[key: string]: any
}

// Initialize Facebook Pixel Script
async function setupFacebookScript(): Promise<void> {
	if (typeof window.fbq === 'function') return

	const f = window
	const b = document
	const e = 'script'
	const v = 'https://connect.facebook.net/en_US/fbevents.js'

	// Create fbq function
	let n: any
	n = f.fbq = function (...args) {
		n.callMethod ? n.callMethod(...args) : n.queue.push(args)
	}

	if (!f._fbq) f._fbq = n
	n.push = n
	n.loaded = true
	n.version = '2.0'
	n.queue = []

	// Create and insert script element
	const t = b.createElement(e)
	t.async = true
	t.src = v
	const s = b.getElementsByTagName(e)[0]
	s.parentNode?.insertBefore(t, s)
	// Wait to ensure the script loads
	await sleep(1000)
}

// Initialize specific pixel ID
export async function initFacebookPixel(pixelId: string = '615167597719467'): Promise<void> {
	await setupFacebookScript()

	// Initialize the pixel
	window.fbq('init', pixelId)
	window.fbq('track', 'PageView')

	// Add noscript pixel
	const noscript = document.createElement('noscript')
	const img = document.createElement('img')
	img.height = 1
	img.width = 1
	img.style.display = 'none'
	img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
	noscript.appendChild(img)
	document.body.appendChild(noscript)
}

// Helper function to check if fbq is available
function isFbqAvailable(): boolean {
	return typeof window !== 'undefined' && typeof window.fbq === 'function'
}

// Main tracking function
export function trackPixel(eventName: string, params: PixelEvent = {}): void {
	if (!isFbqAvailable()) {
		console.warn('Facebook Pixel is not initialized')
		return
	}

	(window as any).fbq('track', eventName, params)
}

// Common tracking events
export function trackPageView(): void {
	trackPixel('PageView')
}

export function trackAddToCart(value: number, currency: string = 'ILS'): void {
	trackPixel('AddToCart', { value, currency })
}

export function trackPurchase(value: number, currency: string = 'ILS'): void {
	trackPixel('Purchase', { value, currency })
}

export function trackLead(): void {
	trackPixel('Lead')
}

export function trackCompleteRegistration(): void {
	trackPixel('CompleteRegistration')
}

export function trackCustomEvent(eventName: string, params: PixelEvent = {}): void {
	trackPixel(eventName, params)
}

// Thank you page specific pixel
export function triggerThankYouPixel(): void {
	initFacebookPixel('615167597719467')
	trackLead()
}
